// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--33U57wbKI","changed":"changed--3OcpfyhBQ"};